module.exports = __webpack_public_path__ + "resources/img/img_prodiscovery5.cb230738533754319949bdf7ae5ec36c.png";